<template>
  <div class="automation-container">
    <div class="config-bar">
      <div class="config-item">
        <span class="label">US价值</span>
        <el-select v-model="ruleForm.declared_price_us" placeholder="请选择" size="mini" style="width: 100px">
          <el-option v-for="item in declared_price_us_options" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </div>

      <div class="config-item">
        <span class="label">物流公司</span>
        <el-select v-model="ruleForm.logistics_company_id" @change="swich_logistics_company" placeholder="请选择" size="mini" style="width: 130px">
          <el-option v-for="item in logistics_company_options" :key="item.id" :label="item.company_name" :value="item.id"></el-option>
        </el-select>
      </div>

      <div class="config-item">
        <span class="label">制单账号</span>
        <el-select v-model="ruleForm.logistics_company_account_id" @change="swich_logistics_company_account" placeholder="请选择" size="mini" style="width: 150px">
          <el-option v-for="item in logistics_company_account_options" :key="item.id" :label="item.label" :value="item.id"></el-option>
        </el-select>
      </div>

      <div class="config-item">
        <span class="label">物流渠道</span>
        <el-select v-model="ruleForm.logistics_channel_code" filterable placeholder="请选择" size="mini" style="width: 180px">
          <el-option v-for="item in logistics_channel_options" :key="item.channel_code" :label="item.channel_name + ' (' + item.channel_code + ')'" :value="item.channel_code"></el-option>
        </el-select>
      </div>
      
      <div class="config-item">
        <span class="label">开启优惠</span>
        <el-select v-model="ruleForm.enable_discount_zip_code" filterable placeholder="请选择" size="mini" style="width: 100px">
          <el-option v-for="item in enable_discount_zip_code_options" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </div>

      <div class="manual-zone">
        <span class="label" style="margin-right: 8px;">当前单号:</span>
        <el-input 
          v-model="ruleForm.order_no" 
          placeholder="等待扫描..." 
          size="mini" 
          clearable
          style="width: 260px; margin-right: 5px;"
          @keyup.enter.native="handleManualPrint"
        >
          <i slot="prefix" class="el-input__icon el-icon-view"></i>
        </el-input>
        <el-button 
          type="warning" 
          size="mini" 
          icon="el-icon-printer" 
          :disabled="!ruleForm.order_no"
          @click="handleManualPrint"
        >搜索订单</el-button>
      </div>
    </div>


    <div class="gray-color">扫码链接：<span>{{camera_url}}</span></div>
  

    <div v-if="current_label" style="height:44px;text-align: center;"><a class="pointer" :href="current_label" target="_blank">{{current_label}}</a></div>

    <div class="monitor-wrapper">
      <div class="monitor-header">
        <div class="status-tags">
          <el-tag :type="wsStatus === '已连接' ? 'success' : 'danger'" size="mini" style="margin-right: 10px">WS: {{ wsStatus }}</el-tag>
          <el-button type="text" size="mini" @click="logs = []">清空日志</el-button>
          <el-button size="small" type="primary" plain icon="el-icon-refresh-right" @click="reconnect">重连服务器</el-button>
          <el-button size="small" icon="el-icon-setting" @click="testLocalPrint">测试打印机</el-button>
        </div>
      </div>
      <div ref="logBox" class="log-content">
        <div v-for="(log, index) in logs" :key="index" :class="['log-line', log.type]">
          <span class="time">[{{ log.time }}]</span>
          <span class="content">{{ log.msg }}</span>
        </div>
        <div v-if="logs.length === 0" class="empty">等待 iPhone 端识别名字推送单号...</div>
      </div>
    </div>


    <div class="automation-container">
      <div v-if="order_list && order_list.length > 0" style="
        display: flex; 
        flex-wrap: wrap; 
        justify-content: flex-start; /* 或者 center */
        gap: 20px; 
        padding: 20px;
      ">
        
        <div v-for="(o, o_index) in order_list" :key="o_index" style="
          border: 2px solid #67C23A; /* 绿色边框 */
          border-radius: 8px;
          padding: 15px;
          background: #fff;
          display: flex;
          flex-direction: column; /* 让内容垂直排：上面是图片区，下面是按钮区 */
          width: fit-content;    /* 宽度根据图片数量自动撑开 */
          min-width: 320px;
          position: relative;
        ">
          
          <div style="position: absolute;top: 0;right: 0;font-size: 100px;color: red;z-index: 10;" v-if="o.lock">已发货</div>
          <ul style="
            display: flex; 
            flex-wrap: nowrap; /* 强迫同一个订单的图片在一行显示，若要自动换行改 wrap */
            gap: 15px;
            list-style: none;
            padding: 0;
            margin: 0 0 15px 0;
          ">
            <li v-for="(im, im_index) in o.show_images" :key="im_index" style="
              width: 333px; /* 适当调小，防止卡片太宽 */
              border: 1px solid #F56C6C; /* 红色边框 */
              padding: 8px;
              text-align: center;
              border-radius: 4px;
            ">
              <el-image
                style="height: 333px; border-radius: 4px;"
                :src="im.src"
                fit="contain"
                :preview-src-list="[im.src]"
              ></el-image>
              <div style="margin-top: 8px; font-size: 12px; font-weight: bold;">{{ im.phone_model }}</div>
            </li>
          </ul>

          <div style="margin-top: auto; text-align: center; border-top: 1px solid #eee; padding-top: 10px;">
            <div style="margin-bottom: 8px; font-size: 13px; color: #666;">
              <el-tag size="mini" type="success" style="margin-left: 5px;">{{ o.order_status_show }}</el-tag><br>
              <b>{{ o.ebay_order_name }}</b><br>
              <b v-if="o.produce_submit_time">{{ o.produce_submit_time }} 生产</b>
              <b v-else>{{ o.produce_submit_time }} 新单</b>
              <p style="border: 1px dashed #aaaaaa;background-color: #efefef;font-size: 12px;">{{o.address_info.last_name}} | {{o.address_info.country_code}} | {{ o.address_info.zip_code }}</p>
            </div>
            <div></div>
            <el-button size="small" plain @click="create_label('点击按钮', o.ebay_order_name)" :disabled="o.lock">打印面单</el-button>
            <el-button size="small" plain @click="send_order(o)" :disabled="o.lock">发货</el-button>
            <a v-if="o.label_pdf" :href="o.label_pdf" target="_black">面单.pdf</a>
            <div v-if="o.hasOwnProperty('remark_list') && o.remark_list && o.remark_list.length > 0">
              <el-tooltip placement="top">
                <div slot="content">
                  <ul>
                    <li v-for="(remark, index_r2) in (o.remark_list)" :key="index_r2" class="seller-remark-list-001">
                      <div v-html="remark.remark_content"></div>
                      <p class="gray-color members">{{ remark.remark_time }} {{ remark.member_name }}</p>
                    </li>
                  </ul>
                </div>
                <b style="font-size: 12px;color: red;">{{o.remark_title}}!!!</b>
              </el-tooltip>
            </div>
          </div>
          
        </div>

      </div>
    </div>

  </div>
</template>

<script>


export default {
  name: "PrintLabelCenter",
  data() {
    return {
      uid:0,
      camera_url:null,
      wsStatus: "未连接",
      socket: null,
      current_label:"",//https://xxx.pdf
      logs: [],
      ruleForm: {
        id: 0,
        order_no:"",
        logistics_company_id: "",
        logistics_company_account_id: "",
        logistics_channel_code: "",
        order_no_list: [],
        factory_orders_id: 0,
        enable_discount_zip_code: 1,
        declared_price_us: 2.00,
      },
      order_list:[],
      declared_price_us_options: [
        { value: 1.39, label: "1.39 USD" }, { value: 1.49, label: "1.49 USD" },
        { value: 1.59, label: "1.59 USD" }, { value: 1.69, label: "1.69 USD" },
        { value: 1.99, label: "1.99 USD" }, { value: 2.00, label: "2.00 USD" },
        { value: 2.49, label: "2.49 USD" }, { value: 2.79, label: "2.79 USD" },
        { value: 3.00, label: "3.00 USD" }, { value: 4.00, label: "4.00 USD" },
        { value: 5.00, label: "5.00 USD" },
      ],
      enable_discount_zip_code_options: [{ value: 1, label: "启用" }, { value: 2, label: "不启用" }],
      logistics_company_options: [],
      logistics_company_account_options: [],
      logistics_channel_options: [],
      produce2_range_options: [],
      wsUrl: true ? "wss://oms.tailorname.com/order-api/ws/print" : "ws://localhost:18009/order-api/ws/print" //wsUrl: "wss://oms.tailorname.com/order-api/ws/print", ws://localhost:18009/order-api/ws/print
    };
  },
  methods: {
    // --- 接口逻辑 (保留所有 select 加载) ---
    get_logistics_company_options() {
      this.$http.post("/v1/pri/logistics-cfg/get-logistics-company-options", {}).then((response) => {
        var res = response.data;
        if (res.code == 1) {
          this.logistics_company_options = res.data.list;
          this.ruleForm.logistics_company_id = res.data.list[0].id;
          this.swich_logistics_company();
        }
      });
    },
    swich_logistics_company() {
      this.ruleForm.logistics_company_account_id = "";
      this.get_logistics_company_account_options();
    },
    swich_logistics_company_account() {
      this.get_logistics_channel_options();
    },
    get_logistics_channel_options() {
      this.$http.post("/v1/pri/logistics-cfg/get-logistics-channel-options", {
        logistics_company_id: this.ruleForm.logistics_company_id,
        logistics_company_account_id: this.ruleForm.logistics_company_account_id,
      }).then((response) => {
        var res = response.data;
        if (res.code == 1) {
          this.logistics_channel_options = res.data.list;
          this.ruleForm.logistics_channel_code = res.data.list[0].channel_code;
        }
      });
    },
    get_logistics_company_account_options() {
      this.$http.post("/v1/pri/logistics-cfg/get-logistics-company-account-options", {
        logistics_company_id: this.ruleForm.logistics_company_id,
      }).then((response) => {
        var res = response.data;
        if (res.code == 1) {
          this.logistics_company_account_options = res.data.list;
          this.ruleForm.logistics_company_account_id = res.data.list[0].id;
          this.get_logistics_channel_options();
        }
      });
    },

    clear_order_info(){
      this.order_list = [] ;
      this.current_label = "";
    },
    get_order_list(ebay_order_names) {
      var ebay_order_name_list = ebay_order_names.split(',')
      this.clear_order_info();
      this.$http.post("/v1/pri/orders/lists", {ebay_order_name_list:ebay_order_name_list, page:1, size:20}).then((response) => {
        var res = response.data;
        this.loading = false;
        if (res.code == 1) {
          var order_list = res.data.list;
          var order_ids = [];
          for(var j=0; j<order_list.length; j++) {
            var order = order_list[j];
            order_ids.push(order.id);

            var images = [];
            var subs = order.detail;
            for (var i=0; i<subs.length; i++) {
              if (subs[i].auto_design && subs[i].auto_design.hasOwnProperty('preview_image_oss')) {
                images.push({
                  src:subs[i].auto_design.preview_image_oss,
                  phone_model:subs[i].produce_model_name,
                })
              }
            }
            order['show_images'] = images;
            order['print_label_loading'] = false;
            order['lock'] = false;
            order_list[j] = order;
          }
          this.order_list = order_list;
          this.getRemarks(order_ids);
        } else {
          this.$message({
            message: res.msg,
            type: "warning",
          });
        }
      });
    },
    getRemarks(order_ids) {
      this.$http.post("/v1/pri/orders/remark-list", { order_ids: order_ids }).then((response) => {
        var res = response.data;
        if (res.code == 1) {
          var remarks = res.data.list;
          var orders = this.order_list;

          for (var i = 0; i < orders.length; i++) {
            var _remark_list = [];
            for (var j = 0; j < remarks.length; j++) {
              if (orders[i].id == remarks[j].order_id) {
                _remark_list.push(remarks[j]);
              }
            }

            if (_remark_list.length > 0) {
              // --- 核心逻辑开始 ---
              // 1. 获取最新的一条备注内容
              let rawContent = _remark_list[0].remark_content || "";
              
              // 2. 正则移除 HTML 标签: <[^>]+> 表示匹配所有 <> 及其内部内容
              let pureText = rawContent.replace(/<[^>]+>/g, "");
              
              // 3. 截取前 10 个字符
              let title = pureText.length > 10 ? pureText.substring(0, 20) + "..." : pureText;

              // 使用 $set 确保 Vue 能够检测到新属性的变化并刷新 UI
              this.$set(orders[i], 'remark_list', _remark_list);
              this.$set(orders[i], 'remark_title', title);
              // --- 核心逻辑结束 ---
            }
          }
          // 如果是用 splice 或者 $set 更新的，这一步其实可以省去，但保留也没问题
          this.order_list = orders;
        }
      });
    },


    set_camera_url(){
      if (!this.uid) {
        this.camera_url = "";
        return;
      }
      const randHex = () => Math.random().toString(16).substring(2, 10).toUpperCase(); 
      const randInt = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;
      const epoch = Date.now(); // 动态时间戳，粉碎一切 iPhone 激进缓存
      const noiseParams = 
        `_trace=${randHex()}` +            // 伪装链路追踪 ID
        `&uid=${this.uid}` +               // 💡 只有这个是真货！
        `&_sign=${randHex()}${randHex()}` + // 伪装加密签名
        `&env_v=${randInt(100, 999)}` +    // 伪装小版本号
        `&_t=${epoch}`;                    // 动态时间戳

      const currentDomain = window.location.origin;
      this.camera_url = `${currentDomain}/camera.html?${noiseParams}`;
      console.log("🔗 精准隔离+高度混淆的 camera_url -> ", this.camera_url);
    },

    // --- 自动化核心 ---
    initWebSocket() {

      this.set_camera_url();

      const finalWsUrl = `${this.wsUrl}?uid=${this.uid}`;
      console.log('finalWsUrl   ============= ', finalWsUrl)
      this.socket = new WebSocket(finalWsUrl);
      this.socket.onopen = () => { this.wsStatus = "已连接"; this.addLog("🚀 推送中枢连通", "success"); };
      this.socket.onmessage = (e) => {
        this.order_list = [];
        console.log('onmessage =========== ', e)
        const data = JSON.parse(e.data);
        console.log('onmessage =====data====== ', data)
        if (data.type === "PRINT_LABEL" && data.order_no) {
          this.get_order_list(data.order_no);
          if ( data.order_no.includes(',') ) {
            this.addLog(`❌ 匹配多个订单，不知道打印哪个，请人工核对: ${data.order_no}`, "error");
            return;
          }
          // this.create_label("已识别", data.order_no);
        }
      };
      this.socket.onclose = () => { this.wsStatus = "断开"; };
    },
    handleManualPrint() {
      if (!this.ruleForm.order_no) {
        this.$message.warning("请输入订单编号");
        return;
      }
      this.get_order_list(this.ruleForm.order_no);
      // this.create_label("手工补打", this.ruleForm.order_no);
    },

    async create_label(source, orderNo) {
      if (!orderNo) return;
      this.addLog(`🔔 [${source}] 开始处理单号: ${orderNo}`, "info");
      this.ruleForm.order_no = orderNo;
      try {
        this.current_label = "";//先清理旧的PDF

        this.$store.commit("setLoading", { text: "正在申请面单.." });
        const response = await this.$http.post("/v1/pri/logistics/create-package-and-label", this.ruleForm);
        this.$store.commit("setLoading", false);
        
        console.log('response ==== ', response)
        const res = response.data;
        if (res.code == 1) {
          this.addLog(`✅ 面单申请成功，正在出纸...`, "success");

          let pdfUrl = res.data.file_pdf;
          if (res.data.file_pdf && !res.data.file_pdf.startsWith('http')) {
            pdfUrl = window.location.origin + res.data.file_pdf;
          }
          this.current_label = pdfUrl;
          console.log('this.order_list === ', this.order_list)
          for(var i=0; i<this.order_list.length; i++) {
            if (this.order_list[i].ebay_order_name == orderNo) {
              this.order_list[i].label_pdf = pdfUrl;
              this.order_list[i].pack = res.data;
              this.$set(this.order_list[i], 'label_pdf', pdfUrl);
              this.$set(this.order_list[i], 'pack', res.data);
              break;
            }
          }

          this.print_label(pdfUrl);

        } else {
         this.$message({
            message: res.msg,
            type: "warning",
          });
          this.addLog(`❌ 申请失败: ${res.msg}`, "error");
        }
      } catch (err) {
        console.log(err)
        this.addLog(`❌ 接口请求异常 ${err}`, "error");
      }
    },
    print_label(pdfUrl) {
      if (!window.LODOP) return;

      this.addLog(`🔍 打印面单: ${pdfUrl}`, "info");

      try {
        window.LODOP.SET_LICENSES("","9F167DB2F1261FBE431925FBD0E02238495","","");
        window.LODOP.PRINT_INIT("Print_" + this.ruleForm.order_no);
        
        window.LODOP.SET_PRINT_MODE("PDF_DOWNLOAD_MODE", 1);

        // 使用补全后的 pdfUrl
        window.LODOP.ADD_PRINT_PDF(0, 0, "100%", "100%", pdfUrl);
        
        window.LODOP.PRINT(); 
      } catch (e) {
        this.addLog(`❌ 打印异常: ${e.message}`, "error");
      }
    },
    send_order(order){
      if (!order.hasOwnProperty('pack') || !order.pack) {
        this.$message({
            message: "无包裹信息",
            type: 'warning'
        });
        return;
      }
      this.$confirm('确定发货?', '发货', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http.post("/v1/pri/orders-step/send-package", {package_id:order.pack.id}).then((response) => {
            this.loading = false;
            var res = response.data;
            if (res.code == 1) {
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              order.lock = true;
              this.$set(order, 'lock', true);
            } else {
              this.$message({
                  message: res.msg,
                  type: 'warning'
              });
            }
          });
        }).catch(() => {});
    },

    addLog(msg, type = "normal") {
      const time = new Date().toLocaleTimeString();
      this.logs.unshift({ time, msg, type });
      if (this.logs.length > 50) this.logs.pop();
    },
    reconnect() { if (this.socket) this.socket.close(); this.initWebSocket(); },
    testLocalPrint() { if (window.LODOP) { window.LODOP.PRINT_INIT("Test"); window.LODOP.ADD_PRINT_TEXT(10,10,200,20,"测试打印正常"); window.LODOP.PREVIEW(); } }
  },
  mounted() {
    this.uid = parseInt(localStorage.getItem("uid"));
    this.get_logistics_company_options();
    const today = new Date().toISOString().split("T")[0];
    this.produce2_range_options = [{ value: today, label: today }];
    this.initWebSocket();
    const s = document.createElement("script");
    s.src = "http://localhost:8000/CLodopfuncs.js?priority=0";
    document.head.appendChild(s);
  }
};
</script>

<style scoped>
.automation-container { padding: 15px; background: #f0f2f5; min-height: 100vh; }
.config-bar { 
  display: flex; align-items: center; gap: 12px; flex-wrap: wrap; 
  background: #fff; padding: 10px 15px; border-radius: 4px; box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}
.config-item { display: flex; align-items: center; gap: 5px; font-size: 13px; }
.label { color: #666; font-weight: bold; }
.manual-zone { border-left: 1px solid #eee; padding-left: 15px; display: flex; align-items: center; }

.monitor-wrapper { margin-top: 15px; background: #fff; border-radius: 4px; padding: 15px; }
.monitor-header { display: flex; justify-content: space-between; border-bottom: 1px solid #eee; padding-bottom: 10px; margin-bottom: 10px; }
.title { font-weight: bold; }
.log-content { 
  background: #2b2b2b; color: #a9b7c6; padding: 15px; height: 155px; 
  overflow-y: scroll; border-radius: 4px; font-family: monospace; 
}
.log-line { margin-bottom: 5px; border-bottom: 1px solid #333; padding-bottom: 3px; font-size: 13px; }
.time { color: #888; margin-right: 10px; }
.success { color: #629755; }
.error { color: #bc3f3c; }
.info { color: #287bde; }
.empty { text-align: center; margin-top: 200px; color: #555; }
.footer-ops { margin-top: 15px; display: flex; align-items: center; gap: 15px; }
.tip { color: #999; font-size: 12px; }
</style>


// WEBPACK FOOTER //
// src/pages/logistics/Label.vue